// src/version.ts
var VERSION = "4.0.436";
export {
  VERSION
};
